import { useEffect } from "react";

export const CustomWindowEvents = {
  onRatingDone: "on-rating-done",
  onLoanApply: "on-loan-apply",
  onQuickPostView: "on-quick-post-view",
  onSERPFilterChange: "on-serp-filter-change",
} as const;

type TypeCustomWindowEvents =
  typeof CustomWindowEvents[keyof typeof CustomWindowEvents];

export const useCustomWindowEvent = (
  event: TypeCustomWindowEvents,
  callback: (e?: CustomEvent) => void
) => {
  useEffect(() => {
    document.addEventListener(event, callback);
    return () => document.removeEventListener(event, callback);
  }, [event, callback]);
};

export type TypeEventDetails = {
  [key: string]: number | string;
};
export const useSetCustomWindowEvent = (
  eventName: TypeCustomWindowEvents,
  data?: CustomEventInit<TypeEventDetails>
) => {
  const event = new CustomEvent(eventName, data);
  document.dispatchEvent(event);
};
